import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, TouchableOpacity } from 'react-native';

import Theme from '../../theme';
import { Heading, HeadingTypes } from '../../components';

const Tab = ({
    active,
    onPress,
    title,
    amountOfTabs,
    currentTabIndex,
    icon,
    useDarkTheme = true,
    borderStyle = {},
}) => {
    const color = active
        ? Theme.PRIMARY
        : Theme.GREY_DARK;

    const fontFamily = active
        ? Theme.CustomBold
        : Theme.Custom600;

    const borderRightWidth =
        (
            currentTabIndex === amountOfTabs
        )
            ? 0
            : 1;

    const borderInactiveStyles = {
        borderRightWidth,
        borderBottomWidth: 1,
        borderTopWidth: 1,
        borderBottomColor: Theme.GREY_LIGHT,
        borderRightColor: Theme.GREY_LIGHT,
    };

    const borderActiveStyles = {
        borderRightWidth,
        borderTopWidth: 1,
        borderBottomWidth: 5,
        borderBottomColor: Theme.PRIMARY,
    };

    const borderStyles = active
        ? { ...borderActiveStyles, ...borderStyle }
        : { ...borderInactiveStyles, ...borderStyle };

    const activeThemeBackgroundColor = useDarkTheme ? Theme.GREY_DARK : Theme.WHITE;
    const notActiveThemeBackgroundColor = useDarkTheme ? Theme.CHARCOAL : Theme.WHITE;

    const backgroundColor = active
        ? activeThemeBackgroundColor
        : notActiveThemeBackgroundColor;

    return (
        <TouchableOpacity
            activeOpacity={0.8}
            onPress={onPress}
            style={[styles.tab, borderStyles, { backgroundColor }]}>
            {icon}
            <Heading
                title={title}
                style={{ ...Theme.textStyle.bodyCopyBold, color, fontFamily }}
                headerType={HeadingTypes.HEADING_TWO}
            />
        </TouchableOpacity>
    );
};

Tab.propTypes = {
    active: PropTypes.bool.isRequired,
    onPress: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    amountOfTabs: PropTypes.number.isRequired,
    amountOfTabs: PropTypes.number.isRequired,
    currentTabIndex: PropTypes.number.isRequired,
    icon: PropTypes.element
};

const styles = StyleSheet.create({
    tab: {
        flex: 1,
        flexBasis: 0,
        flexDirection: 'row',
        borderRightWidth: 1,
        borderTopWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Theme.CHARCOAL,
        borderRightColor: Theme.GREY_LIGHT,
        borderTopColor: Theme.GREY_LIGHT,
    },
});

export default Tab;
